import React, {FC} from 'react';
import styled from 'styled-components';

import {isDefined} from '../../../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Skeleton} from '../../../../common/skeleton';
import {InboxesSearchSuggestionIconProps} from './inboxesSearchSuggestionsDropdownCommons';

/*
 * Props.
 */

export interface SearchSuggestionsDropdownItemIconProps extends InboxesSearchSuggestionIconProps {
  isLoading?: boolean;
}

/*
 * Style.
 */

const StyledSearchSuggestionsDropdownItemIconWrapperDiv = styled.div`
  grid-area: icon;
`;

/*
 * Component.
 */

export const SearchSuggestionsDropdownItemIcon: FC<SearchSuggestionsDropdownItemIconProps> = (props) => {
  const {icon, iconName, iconColor, isLoading} = props;

  const theme = useUserTheme();

  if (isDefined(icon)) {
    return (
      <StyledSearchSuggestionsDropdownItemIconWrapperDiv>
        {icon}
      </StyledSearchSuggestionsDropdownItemIconWrapperDiv>
    );
  }

  return (
    <StyledSearchSuggestionsDropdownItemIconWrapperDiv>
      {isLoading ? (
        <Skeleton width="16px" height="16px" />
      ) : (
        <Icon name={iconName ?? 'searchSmall'} color={iconColor || theme.greys.shade70} />
      )}
    </StyledSearchSuggestionsDropdownItemIconWrapperDiv>
  );
};
